import { render, staticRenderFns } from "./PersistAdminConfigView.vue?vue&type=template&id=00de5cb8&"
import script from "./PersistAdminConfigView.vue?vue&type=script&lang=ts&"
export * from "./PersistAdminConfigView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports